import { render, staticRenderFns } from "./StatsPagination.vue?vue&type=template&id=1bbc4e48&scoped=true&"
import script from "./StatsPagination.vue?vue&type=script&lang=js&"
export * from "./StatsPagination.vue?vue&type=script&lang=js&"
import style0 from "./StatsPagination.vue?vue&type=style&index=0&id=1bbc4e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc4e48",
  null
  
)

export default component.exports